import StorageUtils from '@spothero/utils/storage';
import {setAuthCookie} from 'api/auth/auth';

/**
 * Enum for cookie keys.
 */
enum Cookies {
    AUTH_TOKEN = 'AUTH_TOKEN',
    SH_LOGOUT = 'sh-slo',
    SH_GUEST = 'sh-auth-guest',
}

/**
 * Adds and removes relevant cookies when the user logs out.
 *
 * @function configureLogoutCookies
 */
export const configureLogoutCookies = (): void => {
    StorageUtils.remove(Cookies.AUTH_TOKEN, 'cookie');
    StorageUtils.set(Cookies.SH_LOGOUT, true, 'cookie');
};

/**
 * Adds and removes relevant cookies when the user logs in.
 *
 * @function configureLoginCookies
 */
export const configureLoginCookies = async (): Promise<void> => {
    StorageUtils.remove(Cookies.SH_LOGOUT, 'cookie');
    StorageUtils.remove(Cookies.SH_GUEST, 'cookie');

    await setAuthCookie();
};
